export var initialState = {
    temporaryToken: null,
    temporaryTokenExpiresAt: null,
    temporaryUser: null,
    redirectObject: null,
    loginUrl: '/login',
};
